import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const BasketTotalSkeleton = () => {
  return (
    <>
      <SkeletonBlock $width="45%" $height="20px" />
      <SkeletonBlock $width="55%" $height="20px" />
      <SkeletonBlock $width="35%" $height="20px" />
      <SkeletonBlock $width="100%" $height="40px" />
    </>
  );
};
